<template>
  <section class="container content-padding">
    <div class="row">
      <div class="col-12 text-center">
        <h2>Team Service Calendar</h2>
      </div>
    </div>

    <div class="row" v-if="getHasLogin">
      <div class="col-md-6">
        <table class="table">
          <tbody>
          <tr>
            <td scope="col">จำนวนงานที่รับงานในเดือนนี้</td>
            <td scope="col">{{ statTeams.task_all }} งาน</td>
            <td scope="col">มูลค่า</td>
            <td scope="col">{{statTeams.cost_all | currency}}</td>
          </tr>
          <tr>
            <td>ให้บริการแล้ว</td>
            <td>{{statTeams.task_done}} งาน</td>
          </tr>
          <tr>
            <td>ยังไม่ได้ประเมิน</td>
            <td>{{ statTeams.task_not_feed_backs }} งาน</td>
          </tr>
          <tr>
            <td>ไม่ผ่านเกนฑ์ประเมิน</td>
            <td>
              <template v-if="statTeams.task_not_pass_standard !== 0">
                <a href="#" @click.prevent="fetchServiceRequest(statTeams.arr_id_not_pass)">{{statTeams.task_not_pass_standard}}</a>
              </template>
              <template v-else>
                0
              </template>
              งาน
            </td>
          </tr>
          <tr>
            <td>ผ่านเกนฑ์ประเมิน</td>
            <td>
              <template v-if="statTeams.task_pass_standard !== 0">
                <a href="#"
                   @click.prevent="fetchServiceRequest(statTeams.arr_id_pass)">{{statTeams.task_pass_standard}}</a>
              </template>
              <template v-else>
                0
              </template>
              งาน
            </td>
            <td>มูลค่า</td>
            <td>{{statTeams.cost_task_pass_standard | currency}} บาท</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row" >
      <div class="col-12">
        <div class="box box-info scroll-to-me">
          <div class="box-header" v-show="!loadingFeedbacks && _.size(serviceRequests) > 0">
            <button @click="loadingFeedbacks = true"
              class="btn btn-sm btn-danger float-right">ซ่อน</button>

            <h3>รายงานการประเมิณ คุณภาพการให้บริการ Big Cleaning</h3>
            <div class="table-responsive">
              <table class="table table-bordered " id="">
                <thead>
                <tr>
                  <th width="6%">รหัสงาน</th>
                  <th>ทีมที่ให้บริการ</th>
                  <th width="12%">ชื่อลูกค้า</th>
                  <th>คุณภาพงาน</th>
                  <th>ความตรงต่อเวลา</th>
                  <th>ความสุภาพ/มารยาท</th>
                  <th>ความสะอาดเครื่องมือ/การแต่งกาย</th>
                  <th>อื่นๆ</th>
                </tr>
                </thead>
                <tbody >
                <tr v-for="(service_request, index) in serviceRequests" :key="index">
                  <td>
                    <a target="_blank" :href="service_request.validation_url">{{service_request.id}}</a>
                  </td>
                  <td>
                    <span v-if="service_request.service_team">
                      {{service_request.service_team.name}}
                    </span>
                  </td>
                  <td>
                    {{service_request.name}}
                  </td>
                  <td>
                    <template v-if="service_request.service_request_feedbacks">
                      <span class="badge">คะแนน: {{service_request.service_request_feedbacks.score_quality}}</span><br>
                      <span>{{service_request.service_request_feedbacks.comment_quality}}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="service_request.service_request_feedbacks">
                      <span class="badge">คะแนน: {{service_request.service_request_feedbacks.score_time}}</span><br>
                      <span>{{service_request.service_request_feedbacks.comment_time}}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="service_request.service_request_feedbacks">
                      <span class="badge">คะแนน: {{service_request.service_request_feedbacks.score_service}}</span><br>
                      <span>{{service_request.service_request_feedbacks.comment_service}}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="service_request.service_request_feedbacks">
                      <span class="badge">คะแนน: {{service_request.service_request_feedbacks.score_staff_and_tools_clean}}</span><br>
                      <span>{{service_request.service_request_feedbacks.comment_staff_and_tools_clean}}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="service_request.service_request_feedbacks">
                      <span>{{service_request.service_request_feedbacks.comment}}</span>
                    </template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="calendar-dashboard" v-if="getHasLogin">
      <div class="row">
        <div class="col-md-6">
          <h4><i class="fa fa-calendar"></i> ปฎิทินงาน {{ moment(date).format('MMMM YYYY') }}</h4>
        </div>
        <div class="col-md-6 text-right">
          <div class="btn-group pull-right" role="group" aria-label="Basic example">
            <button type="button"
                    class="btn btn-xs btn-primary"
                    @click="getCalendar(moment(date).add(-1, 'months').format('YYYY-MM-DD'))">
              <i class="fa fa-chevron-left"></i>
            </button>
            <button type="button"
                    class="btn btn-xs btn-primary"
                    @click="getCalendar(moment(date).add(1, 'months').format('YYYY-MM-DD'))">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <ul class="list list-unstyled seven-cols">
            <li class="well calendar-block listcol-xs-12 col-sm-12 col-md-1 col-lg-1 float-left"
                v-for="(rows, index) in calendars" :key="'cal_' + index">
              <h4 :class="{'clear-fix': true, 'title': true, 'text-red': moment(index).format('d') == 0 }">
                          <span class="badge badge-secondary float-left" v-if="_.size(rows) > 0">
                            {{_.size(rows)}}
                          </span> <small>{{ moment(index).format('dddd') }}</small>
                {{ moment(index).format('D') }}
              </h4>
              <span v-for="(row, index) in rows" class="calendar-block" :key="'span_' + index">
                        <span class="clear-fix" v-if="row.team">
                          <span
                            :style="[{ background: `${backgroundTeam(row.team.id)}` }, { marginTop: index >= 1 ? '10px' : ''}]"
                            style="display:block;padding: 2px;border-radius: 5px;color:white;">
                            {{row.team.name}}
                          </span>
                          <div class="text-blue">
                            {{ row.date_time | prettyDate}}
                          </div>
                          <div>
                            <a target="_blank" :href="row.validation_url">
                              #{{ row.service_request.id }}
                            </a>

                          </div>
                        </span>
                        </span>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <div v-else class="login-dashboard">
      <LoginServiceTeam></LoginServiceTeam>
    </div>
  </section>

</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import LoginServiceTeam from './Components/LoginServiceTeam'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'ServiceTeamCalendar',
    components: { LoginServiceTeam },
    data () {
      return {
        teamBigCleanings: [],
        teamSelect: '',
        calendars: [],
        year: moment().format('YYYY'),
        month: moment().format('MM'),
        date: moment().format('YYYY-MM-DD'),
        colors: ['#9c27b0', '#e91e63', '#f44336', '#2196f3', '#009688', '#cddc39', '#ff9800'],
        statTeams: {
          task_all: 0,
          task_done: 0,
          task_not_feed_backs: 0,
          task_not_pass_standard: 0,
          task_pass_standard: 0,
          cost_all: 0,
          cost_task_not_feedback: 0,
          cost_task_not_pass_standard: 0,
          cost_task_pass_standard: 0,
          arr_id_not_feed_backs: [],
          arr_id_task_all: [],
          arr_id_pass: [],
          arr_id_not_pass: []
        },
        loadingFeedbacks: false,
        serviceRequests: []
      }
    },
    computed: {
      ...mapGetters('ServiceTeam', [
        'getHasLogin'
      ]),
      ...mapState({
        member: state => state.ServiceTeam.member
      })
    },
    watch: {
      getHasLogin (newVal) {
        if (this.member && newVal) {
          this.getCalendar()
        }
      }
    },
    methods: {
      backgroundTeam (TeamId = '') {
        return this.colors[TeamId - 1]
      },
      moment: function (date) {
        return moment(date)
      },
      scrollToElement () {
        const el = this.$el.getElementsByClassName('scroll-to-me')[0]

        if (el) {
          el.scrollIntoView()
        }
      },
      async fetchServiceRequest (idArrServiceRequest) {
        this.serviceRequests = []
        this.loadingFeedbacks = true
        let { data } = await axios.get('service-requests/fetch-by-arr-id', {
          params: {
            id_arr: idArrServiceRequest
          }
        })
        this.serviceRequests = await data.service_requests
        this.loadingFeedbacks = false

        this.scrollToElement()
      },
      async getStatTeam (date = null) {
        let idTeamService = this.member ? this.member.service_team_id : ''
        if (!idTeamService) {
          this.$swal({ text: 'ผิดพลาดไม่มี Team Service', type: 'error' })
          return
        }
        let month = this.month
        let year = this.year
        if (date) {
          month = moment(date).format('MM')
          year = moment(date).format('YYYY')
        }
        let { data } = await axios.get('/service-requests/kpi-big-cleaning', {
          params: {
            team_id: idTeamService,
            month: month,
            year: year
          }
        })
        if (data.error) {
          this.$swal({ text: 'ผิดพลาด ' + data.message, type: 'error' })
          return
        }
        this.statTeams = data.stat_team
      },
      async getCalendar (date = null) {
        let idTeamService = this.member ? this.member.service_team_id : ''
        if (!idTeamService) {
          this.$swal({ text: 'ผิดพลาดไม่มี Team Service', type: 'error' })
          return
        }
        this.$store.dispatch('ServiceTeam/CHECK_STATUS_WORK')
        this.$swal.showLoading()
        let url = 'service-team/calendar?team_id=' + idTeamService
        if (date !== null) {
          url += '&year=' + moment(date).format('YYYY') + '&month=' + moment(date).format('MM')
          this.year = moment(date).format('YYYY')
          this.month = moment(date).format('MM')
          this.date = moment(date).format('YYYY-MM-DD')
        }
        this.getStatTeam(date)
        let { data } = await axios.get(url)
        this.calendars = data.data

        this.$swal.close()
      }
    },
    created () {
      if (this.member && this.getHasLogin) {
        this.$store.commit('ServiceTeam/CLEAR_DATA_STATE')
        /* this.$store.dispatch('ServiceTeam/CHECK_STATUS_WORK').then(res => {
          this.getCalendar()
        }) */
      }
    }
  }
</script>

<style scoped lang="scss">
  .calendar-block {
    height: 160px;
    overflow: auto;
  }

  .calendar-block .text-red {
    color: red;
  }

  .calendar-block .title {
    width: 100%;
    display: inline-block;
    padding-bottom: 4px;
    text-align: right;
    border-bottom: 1px solid #d0d0d0;
  }

  .calendar-block .text-blue {
    color: #46b7df;
  }

  .calendar-block .text-green {
    color: #59b122;
  }


  .well {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
  }


  @media (min-width: 992px) {
    .seven-cols .col-md-1,
    .seven-cols .col-sm-1,
    .seven-cols .col-lg-1 {
      max-width: 14.285714285714285714285714285714%;
      *max-width: 14.285714285714285714285714285714%;
    }
  }

  /**
   *  The following is not really needed in this case
   *  Only to demonstrate the usage of @media for large screens
   */
  @media (min-width: 1200px) {
    .seven-cols .col-md-1,
    .seven-cols .col-sm-1,
    .seven-cols .col-lg-1 {
      max-width: 14.285714285714285714285714285714%;
      *max-width: 14.285714285714285714285714285714%;
    }
  }


  @media (max-width: 992px) {

    .calendar-block {
      height: 80px;
      overflow: auto;
    }

    .seven-cols .col-md-1,
    .seven-cols .col-sm-1,
    .seven-cols .col-lg-1 {
      max-width: 14.285714285714285714285714285714%;
      *max-width: 14.285714285714285714285714285714%;
    }

    .seven-cols li.well {
      padding: 5px;
      font-size: 6px;
    }

    div.btn-group {
      margin-bottom: 20px;

      button {
        font-size: 12px;
      }
    }

    div.main-section {
      width: auto;
    }

    div.mCustomScrollbar.mCustomScrollbar {
      padding: 0;
    }

    .left-section .chatList .desc {

      .time {
        position: static;
      }

      width: auto;
    }


    div.message ul li.msg-right {

      small {
        margin-top: 23px;
      }

      .msg-desc {
        margin-right: 0;
        white-space: nowrap;
      }

    }

    li.calendar-block {
      min-height: 80px;
      overflow: scroll;
      font-size: 12px;

      h4.title {
        font-size: 6px;
      }

    }

  }

  .calendar-block {
    height: 160px;
    overflow: auto;
  }

  .calendar-block .text-red {
    color: red;
  }

  .calendar-block .title {
    width: 100%;
    display: inline-block;
    padding-bottom: 4px;
    text-align: right;
    border-bottom: 1px solid #d0d0d0;
  }

  .calendar-block .text-blue {
    color: #46b7df;
  }

  .calendar-block .text-green {
    color: #59b122;
  }
</style>



// WEBPACK FOOTER //
// src/components/serviceRequest/ServiceTeamCalendar.vue